import { css } from '@emotion/react';
import { Colors, Typography } from '@zapier/design-system';

export const globalStyles = css`
  body {
    display: block;
    font-family: ${Typography.base.fontFamily};
    background-color: ${Colors.neutral100};
    font-style: normal;
    font-weight: normal;
    margin: 0;
  }
`;
